import { default as routes } from './routes';
import { default as topics } from './topics';

export default {
    ...routes,
    ...topics
};
